import { Injectable } from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class JSONToFormService {
  constructor(private readonly fb: UntypedFormBuilder) {}

  build(input: any): AbstractControl {
    if (
      typeof input === 'string' ||
      typeof input === 'number' ||
      typeof input === 'boolean'
    ) {
      return this.buildControl(input);
    }
    if (typeof input === 'object' && Array.isArray(input)) {
      return this.buildArray(input);
    }

    return this.fb.group(
      Object.entries(input).reduce((formGroup, [key, value]) => {
        switch (typeof value) {
          case 'boolean':
          case 'number':
          case 'string': {
            return {
              ...formGroup,
              [key]: this.buildControl(value),
            };
          }
          case 'object': {
            if (Array.isArray(value)) {
              return {
                ...formGroup,
                [key]: this.buildArray(value),
              };
            } else {
              return {
                ...formGroup,
                [key]: this.buildGroup(value),
              };
            }
          }
          default: {
            console.warn('value type %s from %s is not supported', value, key);
          }
        }
      }, {}),
    );
  }

  private buildGroup<T extends object>(input: T): UntypedFormGroup {
    return this.build(input) as UntypedFormGroup;
  }

  private buildControl(input: string | number | boolean): UntypedFormControl {
    return this.fb.control(input);
  }

  private buildArray<T extends object | string | number>(
    input: T[],
  ): UntypedFormArray {
    return this.fb.array(input.map((i) => this.build(i)));
  }
}
